<template>
  <CCFilhoDetalhesModal
    v-if="showCCFilhoDetalhesModal"
    :codCCustoPai="codCCustoPai"
    :orcamentoId="orcamentoSelecionado.id"
    :codCCustoFilho="codCCustoFilhoSelecionado"
    @closeModal="showCCFilhoDetalhesModal = false"
  />
  <LoadingData v-if="loadData" />
  <ListCCFilhosResumo
    v-else
    :codCCustoPai="codCCustoPai"
    :centrosCustosFilhos="centrosCustosFilhos"
    @showDetalhesCentroCustoFilho="showDetalhesCentroCustoFilho"
  />
  <Receitas v-if="showReceitas" :codCCustoPai="codCCustoPai" />
</template>

<script>
import CCFilhoDetalhesModal from '@/components/centroCusto/CCFilhoDetalhesModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListCCFilhosResumo from '@/components/centroCusto/ListCCFilhosResumo.vue'
import Receitas from '@/components/receitas/Receitas.vue'
import { mapGetters } from 'vuex'
import { moneyToCurrencyBr } from '@/utils/strings'

export default {
  name: 'CCPaiDetalhes',

  components: {
    CCFilhoDetalhesModal,
    LoadingData,
    ListCCFilhosResumo,
    Receitas,
  },

  data() {
    return {
      codCCustoPai: this.$route.params.codCCustoPai,
      loadData: true,
      showCCFilhoDetalhesModal: false,
      centrosCustosFilhos: {},
      showReceitas: false,
      codCCustoFilhoSelecionado: '',
      moneyToCurrencyBr,
    }
  },

  computed: {
    ...mapGetters(['orcamentoSelecionado']),
  },

  watch: {
    orcamentoSelecionado: {
      handler(newVal, oldVal) {
        if ((!oldVal && newVal) || newVal.id !== oldVal.id) {
          this.getResumoCentrosCustosFilhos()
        }
      },
      immediate: true,
    },
  },

  methods: {
    async getResumoCentrosCustosFilhos() {
      if (this.orcamentoSelecionado.id !== '') {
        try {
          this.showReceitas = false
          this.centrosCustosFilhos = await this.$store.dispatch(
            'getResumoCentrosCustosFilhos',
            {
              codCCustoPai: this.codCCustoPai,
              orcamentoId: this.orcamentoSelecionado.id,
            },
          )
          this.showReceitas = true
          this.loadData = false
        } catch (error) {
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },

    showDetalhesCentroCustoFilho(centroCustoFilho) {
      if (!centroCustoFilho.bloqueado) {
        this.codCCustoFilhoSelecionado = centroCustoFilho.codCCustoFilho
        this.showCCFilhoDetalhesModal = true
      }
    },
  },
}
</script>
